import { Tag as TagComponent } from './Tags';
import { Icon, IconName } from './Icon';
import { Tag } from '../types/tags.types';
import '../../../styles/components/tags.css';

// Mapping des tags d'activité vers leurs icônes Lucide
const TAG_ICONS: Record<string, IconName> = {
  'free': 'Gift',
  'music': 'Music',
  'sports': 'Trophy',
  'art': 'Palette',
  'food': 'Utensils',
  'culture': 'Landmark',
  'yoga': 'Heart',
  'spirituality': 'Sparkles',
  'children': 'Baby',
  'party': 'PartyPopper',
};

type TagListProps = {
  tags: Tag[];
  onTagSelect: (tagId: string) => void;
  selectedTags: string[];
  maxTags?: number;
  onMaxTagsReached?: () => void;
  size?: 'sm' | 'md' | 'lg';
};

const TagList = ({
  tags,
  onTagSelect,
  selectedTags,
  maxTags,
  onMaxTagsReached,
  size = 'lg'
}: TagListProps) => {
  const handleTagSelect = (tagId: string) => {
    if (selectedTags.includes(tagId)) {
      // Si le tag est déjà sélectionné, on le retire
      onTagSelect(tagId);
    } else if (!maxTags || selectedTags.length < maxTags) {
      // Si pas de limite ou limite non atteinte, on ajoute le tag
      onTagSelect(tagId);
    } else if (onMaxTagsReached) {
      // Si limite atteinte, on notifie
      onMaxTagsReached();
    }
  };

  return (
    <div className="ds-taglist">
      {tags.map((tag) => {
        const isSelected = selectedTags.includes(tag.id);
        const isDisabled: boolean = Boolean(!isSelected && maxTags && selectedTags.length >= maxTags);

        const iconName = TAG_ICONS[tag.id];

        const iconSize = size === 'sm' ? 12 : size === 'md' ? 14 : 16;

        return (
          <button
            key={tag.id}
            onClick={() => handleTagSelect(tag.id)}
            className={`ds-taglist__button ${isSelected ? 'ds-taglist__button--selected' : ''} ${isDisabled ? 'ds-taglist__button--disabled' : ''}`}
            aria-pressed={isSelected}
            disabled={isDisabled}
            title={isDisabled ? `Maximum ${maxTags} tags allowed` : undefined}
          >
            <TagComponent
              label={
                iconName ? (
                  <>
                    <Icon name={iconName} size={iconSize} />
                    {tag.label}
                  </>
                ) : `${tag.icon} ${tag.label}`
              }
              type="activity"
              size={size}
            />
          </button>
        );
      })}
    </div>
  );
};

export default TagList;